export enum PurchaseTypes {
    COURSE = 'course',
    LIBRARY = 'library',
    EVENT = 'event',
    GROUP_PLAN = "group-plan",
    GROUP_PLANS = 'group-plans',
}